// @ts-check

import React from "react"
import { BilledTimeCell } from "../../../../components/molecules/reports/BilledTimeCell.molecule"
import { TimeDifferenceCell } from "../../../../components/molecules/reports/TimeDifferenceCell.molecule"
import { SelectCell } from "../../../../components/molecules/reports/SelectCell.molecule"
import { SelectHeader } from "../../../../components/molecules/reports/SelectHeader.molecule"
import { createTaskReportsCommonCells } from "../../../../factories/reports/createTaskReportsCommonCells.factory"
import { GroupedDateCell } from "../../../../components/molecules/reports/GroupedDateCell.molecule"

/** @param {import("./IndividualReportTable.controller.types").IndividualReportTableHeaderContext<unknown>} ctx */
export const SelectHeaderTemplate = (ctx) => <SelectHeader ctx={ctx} />

/** @param {import("./IndividualReportTable.controller.types").IndividualReportTableCellContext<unknown>} ctx */
export const SelectCellTemplate = (ctx) => <SelectCell ctx={ctx} />

/** @param {import("./IndividualReportTable.controller.types").IndividualReportTableCellContext<unknown>} ctx */
const GroupedDateCellTemplate = (ctx) => <GroupedDateCell ctx={ctx} />

/**
 * @param {import("./IndividualReportTable.cells.types").IndividualReportTableCellsParams} params
 */
export function buildIndividualReportTableCells(params) {
  const {
    setContextMenuTarget,
    isHoldingModifierDown,
    onLeftClickClientCode,
    schemaRules,
    teamMemberWorkAnniversaryDate,
    userIsAdmin,
    updatingTask,
    contextMenuRef,
    totals,
  } = params

  const {
    DateCellTemplate,
    ProjectCodeCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
    SisuTimeFooterTemplate,
    BilledTimeFooterTemplate,
    TimeDifferenceFooterTemplate,
    ActionsCellTemplate,
  } = createTaskReportsCommonCells(
    /** @type {import("../../../../factories/reports/createTaskReportsCommonCells.factory.types").CreateTaskReportsCommonCellsParams<
        import("../../../../services/reports.service.types").IndividualTaskReportRecord
      >} */ ({
      totals,
      isHoldingModifierDown,
      onLeftClickClientCode,
      userIsAdmin,
      updatingTask,
      contextMenuRef,
      setContextMenuTarget,
    })
  )

  /** @param {import("./IndividualReportTable.controller.types").IndividualReportTableCellContext<number>} ctx */
  const BilledTimeCellTemplate = (ctx) => (
    <BilledTimeCell
      ctx={ctx}
      teamMemberSchemaRules={schemaRules}
      teamMemberWorkAnniversaryDate={teamMemberWorkAnniversaryDate}
    />
  )

  /** @param {import("./IndividualReportTable.controller.types").IndividualReportTableCellContext<number>} ctx */
  const TimeDifferenceCellTemplate = (ctx) => (
    <TimeDifferenceCell
      ctx={ctx}
      teamMemberSchemaRules={schemaRules}
      teamMemberWorkAnniversaryDate={teamMemberWorkAnniversaryDate}
    />
  )

  return {
    DateCellTemplate,
    GroupedDateCellTemplate,
    ProjectCodeCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    SisuTimeFooterTemplate,
    BilledTimeCellTemplate,
    BilledTimeFooterTemplate,
    TimeDifferenceCellTemplate,
    TimeDifferenceFooterTemplate,
    ActionsCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
  }
}
